const categories = ['All', 'Floral', 'Geometric', 'Figurative', 'Landscape', 'Animals'];
export function readDirectoryState(href) {
  const params = new URL(href).searchParams;
  return {tab: params.get('tab') === 'collab' ? 'collab' : 'archive', category: categories.includes(params.get('category')) ? params.get('category') : 'All'};
}
export function directoryUrl(href, state) {
  const url = new URL(href);
  url.searchParams.set('tab', state.tab);
  if (state.category === 'All') url.searchParams.delete('category');
  else url.searchParams.set('category', state.category);
  url.hash = '';
  return url.href;
}
export function matchesArtist(categories, selected) {
  return selected === 'All' || categories.split('|').includes(selected);
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-artist-directory]').forEach(root => {
    let state = readDirectoryState(location.href);
    const tabs = [...root.querySelectorAll('[data-artist-tab]')];
    const filters = [...root.querySelectorAll('[data-artist-category]')];
    const render = () => {
      root.dataset.activeTab = state.tab;
      root.querySelector('[data-artist-intro]').textContent = state.tab === 'archive'
        ? 'We translate the work of overlooked artists into hand-tufted wool — pieces you can actually touch.'
        : 'Living artists whose work we license, produce, and pay royalties on.';
      tabs.forEach(tab => {
        const selected = tab.dataset.artistTab === state.tab;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter.dataset.artistCategory === state.category)));
      let count = 0;
      root.querySelectorAll('[data-artist-panel]').forEach(panel => {
        panel.hidden = panel.dataset.artistPanel !== state.tab;
        panel.querySelectorAll('[data-artist-categories]').forEach(card => {
          card.hidden = !matchesArtist(card.dataset.artistCategories, state.category);
          if (!panel.hidden && !card.hidden) count++;
        });
      });
      root.querySelector('[data-artist-empty]').hidden = count !== 0;
      root.querySelector('[data-artist-count]').textContent = `${count} ${count === 1 ? 'artist' : 'artists'}`;
    };
    const change = next => {
      state = next;
      history.pushState(null, '', directoryUrl(location.href, state));
      render();
    };
    tabs.forEach(tab => {
      tab.setAttribute('role', 'tab');
      tab.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        change({...state, tab: tab.dataset.artistTab});
      });
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[index].focus();
        change({...state, tab: tabs[index].dataset.artistTab});
      });
    });
    root.querySelector('[data-artist-tabs]').setAttribute('role', 'tablist');
    root.querySelectorAll('[data-artist-panel]').forEach(panel => panel.setAttribute('role', 'tabpanel'));
    filters.forEach(filter => filter.addEventListener('click', () => change({...state, category: filter.dataset.artistCategory})));
    window.addEventListener('popstate', () => {state = readDirectoryState(location.href); render();});
    root.querySelector('[data-artist-filters]').hidden = false;
    render();
  });
}
